import React from "react";
import cx from "classnames";
import { Link } from "gatsby";

import { ReactComponent as ButtonEndLeft } from "src/images/svg/ButtonEndLeft.svg";
import { ReactComponent as ButtonEndRight } from "src/images/svg/ButtonEndRight.svg";

import * as styles from "./button.module.css";

export const Button = ({
  onClick,
  tag = "button",
  target,
  copy,
  className,
  disabled,
  style = "stroke",
  color = "gold",
  type,
}) => {
  const Tag = tag === "button" ? "button" : Link;

  return (
    <div className={className}>
      <Tag
        to={target}
        type={type}
        onClick={onClick ? onClick : null}
        className={cx(styles.button, styles[style], styles[color])}
        disabled={disabled}
      >
        <span className={styles.buttonInner}>
          <ButtonEndLeft />
          <span className={cx("label-italic", styles.copy)}>{copy}</span>
          <ButtonEndRight />
        </span>
      </Tag>
    </div>
  );
};
